import React, { Component, useEffect } from "react";
import { connect } from "react-redux";
import AddAdminComp from "./AddAdmin";
import EditAdminUserComp from "./EditAdmin";

import { getServerDataWithTypes } from "../../../../action/common_action";
import { ANY_ERROR } from "../../../../action/user_action_types";
import {
  SALES_USERS_DATA,
  STATE_LIST,
} from "../../../../action/salesUser_action_types";

import SideBar from "../../common/sideBar";
import { history } from "../../../../history/history";
import Pagination from "../../../common/Pagination";
import { endPoints } from "../../../../config";
import NoData from "../../common/NoData";
import http from "../../../../util/http";
import moment from "moment";
import HeaderAdminpanel from "../../common/HeaderAdminpanel";
import { axiosInstnace, getAdminData } from "../../../../util/util";
import { CommonModelImpl } from "../../../admin/common/CommonModel";
import { axiosInstnace as Axios } from "../../../../util/util";

class SalesUsersListComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 10,
      totalRecords: 0,
      salesUsersData: [],
      showAddAdminPopup: false,
      showCreateClusterPopup: false,
      showUpdateAdminPopup: false,
      showDeletePopup: false,
      tps: false,
      showeditTppopup: false,
      replacementuser: "",
      msg: "",
      adminData: getAdminData(),
      selectedAdminId: "",
      stationList: "",
      searchField: {
        name: "",
        email: "",
        station: "",
        state: "",
        city: "",
      },
      selectedClusterData: "",
      selectedrole: "",
      clusterdata: [],
      roleList: [
        { role: "", name: "Choose Role" },
        { role: "salesUser", name: "Sales User" },
        { role: "auditAdmin", name: "Audit Admin" },
        { role: "stationAdmin", name: "Station Admin" },
        { role: "trafficAdmin", name: "Traffic Admin" },
        { role: "clusterAdmin", name: "Cluster Admin" },
      ],
    };
  }

  //Handle the admin fields
  handleChange = (event) => {
    console.log(event.target);
    let { name, email, station, state, city, value } = event.target;
    let { searchField } = this.state;
    this.setState({
      searchField: {
        ...searchField,
        [name]: value,
        [email]: value,
        [state]: value,
        [city]: value,
        [station]: value,
      },
    });

    console.log("Changed value", this.state.searchField);
  };

  getClusterData = async () => {
    try {
      const response = await Axios.get(`${endPoints.getClusters}`, {
        params: {
          type: "all",
          withoutTradepartnerList: true
        },
      });
      let result = response.data.data.allData;
      result = result
        .map((e) => {
          return e.name;
        })
        .sort();
      if (result) {
        this.setState({
          clusterdata: result,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    // check whether client has changed
    if (prevProps.client !== this.props.client) {
      this.fetchData(this.props.salesUsersData);
    }
  }

  addAdmin = (data) => {
    this.serverCalls(endPoints.addAdminUser, data);
    this.showHideAddAdminPopup();
  };

  updateAdmin = (data) => {
    this.serverCalls(endPoints.updatesalesUserdata, data);
    this.showHideUpdateAdminPopup();
  };

  //vj
  getAdmin = (data) => {
    this.serverCalls(endPoints.updatesalesUserdata, data);
    this.showHideUpdateAdminPopup();
  };

  //vj

  //Fetch all admin
  getAllData = (skip) => {
    let { limit } = this.state;
    let page = skip / limit + 1;
    this.setState({ page }, () => {
      this.componentDidMount();
    });
  };

  //make a call to fetch admin
  componentDidMount = async () => {
    let { page } = this.state;
    let url = `${endPoints.getAdminsData}?page=${page}`;
    this.props.getAdminsData(url, ADMINS_DATA);
    
  };

  //Set data of admin to state
  componentWillReceiveProps = (nextProps) => {
    let { adminsData } = nextProps;
    if (adminsData) {
      let { allData, count } = adminsData;
      this.setState({
        adminsData: allData ? allData : [],
        totalRecord: count ? count : 0,
      });
    }
  };

  //Getting all sales User
  componentDidMount = async() => {
    let { page } = this.state;
    this.getAllSalesUsers(page);
    this.getClusterData();
    const data = await axiosInstnace.get(endPoints.getCityStateRate, {
      params: { limit: false },
    });
    
    let result = data.data.data.data;
    this.setState({
      stationList: result.map((e) => e.station),
    });
  };

  componentWillMount = () => {
    this.getAllStates();
  };

  getAllStates = () => {
    this.props.getStateList(`${endPoints.getStateList}`, STATE_LIST);
  };
  clearSearch = () => {
    window.location.reload(true);
  };

  //Delete a admin
  deleteAdmin = () => {
    let { currentAdmin } = this.state;
    let { _id } = currentAdmin;
    if (this.state.tps && !this.state.replacementuser) {
      this.setState({
        showeditTppopup: true,
        showDeletePopup: false,
      });
      return;
    }
    let data = { _id };
    this.serverCalls(endPoints.deleteAdmin, data);
    this.setState({
      page: 1,
      currentAdmin: {},
      msg: "",
      showDeletePopup: false,
    });
  };

  replaceANDdeleteAdmin = (user) => {
    let { currentAdmin } = this.state;
    let { _id } = currentAdmin;
    let data = { _id , replaceuser: user};
    this.serverCalls(endPoints.deleteAdmin, data);
    this.setState({
      page: 1,
      currentAdmin: {},
      msg: "",
      showDeletePopup: false,
    });
  };

  //Show hide delete popup
  showHideDeletePopup = (currentAdmin) => {
    let { adminData } = this.state;
    if (currentAdmin && currentAdmin.email == adminData.email) {
      return this.props.showError("You can not delete yourself!");
    }
    this.setState({
      currentAdmin: currentAdmin ? currentAdmin : {},
      msg: currentAdmin  && currentAdmin.tps > 0 ? "Are you sure you want to transfer reponsibilities and delete this Admin?": "Are you sure you want to delete?",
      showDeletePopup: !this.state.showDeletePopup,
      tps: currentAdmin.tps > 0 ? true : false,
    });
  };

  //vj

  //Fetching all sales user bassed on page
  getAllSalesUsers = (page) => {
    let { state, station, city, email, name } = this.state.searchField;
    this.props.getSalesUsers(
      `${endPoints.getAllSalesUsers}?page=${page}&state=${state}&station=${station}&city=${city}&email=${email}&name=${name}&cluster=${this.state.selectedClusterData}&role=${this.state.selectedrole}`,
      SALES_USERS_DATA
    );
    this.setState({ page });
  };

  //Set sales user data to state
  componentWillReceiveProps = (nextProps) => {
    console.log("on Data receive", nextProps);
    let { salesUsersData } = nextProps;
    this.setState({
      salesUsersData:
        salesUsersData && salesUsersData.allSalesUsers
          ? salesUsersData.allSalesUsers
          : [],
      totalRecords:
        salesUsersData && salesUsersData.totalRecord
          ? salesUsersData.totalRecord
          : 0,
    });
  };

  //Show hide add admin popup
  showHideAddAdminPopup = () => {
    this.setState({
      showAddAdminPopup: !this.state.showAddAdminPopup,
    });
  };

  showHideCreateClusterPopup = () => {
    this.setState({
      showCreateClusterPopup: !this.state.showCreateClusterPopup,
    });
  };

  //Show hide add admin popup
  showHideUpdateAdminPopup = (adminId) => {
    //console.log(adminId);
    this.setState({
      selectedAdminId: adminId,
      showUpdateAdminPopup: !this.state.showUpdateAdminPopup,
    });
  };

  serverCalls = async (url, data) => {
    const response = await http.post(url, data);
    if (response && response.data.statusCode == 200) {
      this.componentDidMount();
    } else {
      this.props.showError(
        response ? response.data.message : "Something is wrong"
      );
    }
  };

  //Redirect to route bassed on path
  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };

  //Return the table for sales user
  render() {
    let {
      salesUsersData,
      totalRecords,
      page,
      limit,
      showAddAdminPopup,
      showDeletePopup,
      showeditTppopup,
      showCreateClusterPopup,
      showUpdateAdminPopup,
      msg,
      adminData,
    } = this.state;
    let indexNum = (page - 1) * limit;
    let { email, name, state, station, city } = this.state.searchField;
    return (
      <div className="dashboardContainer">
        <HeaderAdminpanel />

        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>
          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Sales User Management |
                <span className="breadcrumb-active fct-breadcrumb">
                  Sales User List
                </span>
              </div>

              {localStorage.getItem("adminRole") &&
                (localStorage.getItem("adminRole") === "admin" ||
                  localStorage.getItem("adminRole") === "campaignAdmin" ||
                  localStorage.getItem("adminRole") === "auditAdmin") && (
                  <div className="search_camp">
                    <button
                      onClick={this.showHideAddAdminPopup}
                      className="search_camp_btn"
                    >
                      Add
                    </button>
                  </div>
                )}

              <table cellPadding="10" cellSpacing="10" className="searchTable">
                <tbody>
                  <tr>
                    <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          value={name}
                          name="name"
                          onChange={this.handleChange}
                          placeholder="Enter Name"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>
                      </div>
                    </td>

                    <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          value={email}
                          name="email"
                          onChange={this.handleChange}
                          placeholder="Enter Email"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="status-input search_camp search_list">
                        <select
                          className="packageType drop-down-icon status-dropdown"
                          onChange={(e) =>
                            this.setState({
                              selectedrole: e.target.value,
                            })
                          }
                        >
                          {this.state.roleList.map((role, index) => (
                            <option key={index} value={role.role}>
                              {role.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </td>
                    <td>
                      <div className="status-input search_camp search_list">
                        <select
                          className="packageType drop-down-icon status-dropdown"
                          onChange={(e) => {
                            this.setState({
                              selectedClusterData: e.target.value,
                            });
                          }}
                        >
                          <option value="" disabled selected hidden>
                            Choose ClusterName{" "}
                          </option>{" "}
                          {this.state.clusterdata.map((cluster) => (
                            <option> {cluster} </option>
                          ))}{" "}
                        </select>{" "}
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          value={station}
                          name="station"
                          onChange={this.handleChange}
                          placeholder="Enter Station "
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>
                      </div>
                    </td>

                    <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          value={state}
                          name="state"
                          onChange={this.handleChange}
                          placeholder="Enter State"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>
                      </div>
                    </td>

                    <td>
                      <div className="status-input search_camp search_list">
                        <input
                          type="text"
                          value={city}
                          name="city"
                          onChange={this.handleChange}
                          placeholder="Enter City"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>
                      </div>
                    </td>

                    <td>
                      <span className="print_btn">
                        <button onClick={this.componentDidMount}>Search</button>
                      </span>
                      <span className="print_btn mrgLft10px">
                        <button onClick={this.clearSearch}>Clear</button>
                      </span>
                    </td>
                  </tr>

                  {/*<tr>
                      <td colspan="5">

                      </td>
                    </tr>*/}
                </tbody>
              </table>
            </div>
            <div
              className={
                salesUsersData.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Last Login</th>
                    <th>Total Campaigns</th>
                    <th>Mobile </th>
                    <th>Role </th>
                    <th>Cluster</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Station</th>
                    {localStorage.getItem("adminRole") &&
                      (localStorage.getItem("adminRole") === "admin" ||
                        localStorage.getItem("adminRole") ===
                          "campaignAdmin") && (
                        <th className="txt-cntr">Delete</th>
                      )}
                    {localStorage.getItem("adminRole") &&
                      (localStorage.getItem("adminRole") === "admin" ||
                        localStorage.getItem("adminRole") ===
                          "campaignAdmin") && <th>Edit</th>}
                  </tr>
                </thead>
                <tbody>
                  {salesUsersData.map((saller, index) => {
                    indexNum++;
                    return (
                      <tr key={index}>
                        <td>{indexNum}</td>
                        <td>{saller.name}</td>
                        <td>{saller.email}</td>
                        <td>
                          {saller.lastLogin && (
                            <span>
                              {moment(saller.lastLogin).format(
                                "DD/MM/YYYY hh:mm A"
                              )}
                            </span>
                          )}
                          {!saller.lastLogin && <span>NA</span>}
                        </td>
                        <td>
                          <a
                            onClick={() =>{
                              this.goToRoute(
                                "sallerCampaigns",
                                saller.campaigns,
                                "/admin/salesuser/campaigns"
                              )
                            }
                            }
                          >
                            {saller.campaigns.length}
                          </a>
                        </td>
                        <td>{saller.mobile}</td>
                        <td>{saller.role}</td>
                        <td>{saller.cluster}</td>
                        <td>{saller.state}</td>
                        <td>{saller.city}</td>
                        <td>{saller.station}</td>
                        {localStorage.getItem("adminRole") &&
                          (localStorage.getItem("adminRole") === "admin" ||
                            localStorage.getItem("adminRole") ===
                              "campaignAdmin") && (
                            <td className="txt-cntr">
                              <a>
                                <span className="tooltip-reject">
                                  <img
                                    src="/assets/images/delete.png"
                                    className="reject-approved-img reject-png"
                                    onClick={() =>
                                      this.showHideDeletePopup(saller)
                                    }
                                  />
                                  <span>Delete</span>
                                </span>
                              </a>
                            </td>
                          )}
                        {localStorage.getItem("adminRole") &&
                          (localStorage.getItem("adminRole") === "admin" ||
                            localStorage.getItem("adminRole") ===
                              "campaignAdmin") && (
                            <td className="txt-cntr">
                              <a>
                                <span className="tooltip-reject">
                                  <img
                                    src="/assets/images/edit-1.png"
                                    className="edit-img-icon reject-png"
                                    onClick={() =>
                                      this.showHideUpdateAdminPopup(saller)
                                    }
                                  />
                                  <span>Edit</span>
                                </span>
                              </a>
                            </td>
                          )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="paginationTable">
                {totalRecords > 10 && (
                  <Pagination
                    getAllData={this.getAllSalesUsers}
                    totalRecords={totalRecords}
                  />
                )}
              </div>
            </div>
            {salesUsersData.length === 0 ? <NoData /> : null}
            {showAddAdminPopup && (
              <AddAdminComp
                addAdmin={this.addAdmin}
                hidePopup={this.showHideAddAdminPopup}
              />
            )}
            {showUpdateAdminPopup && (
              <EditAdminUserComp
                updateAdmin={this.updateAdmin}
                adminDetail={this.state.selectedAdminId}
                hidePopup={this.showHideUpdateAdminPopup}
              />
            )}
            {/* {showCreateClusterPopup && 
          <CreateClusterComp
            hidePopup = {this.showHideCreateClusterPopup}
          />
        } */}
            {showDeletePopup && (
              <CommonModelImpl
                headerMsg={
                  this.state.tps > 0 ? "Replace and Delete Admin" : "Admin Delete"
                }
                msg={msg}
                okButtonShow={true}
                okButtonText={"PROCEED"}
                okAction={ this.state.tps > 0 ? this.replaceANDdeleteAdmin : this.deleteAdmin}
                stationList = {this.state.stationList}
                currentAdmin ={this.state.currentAdmin}
                cancelButtonShow={true}
                tps={this.state.tps}
                cancelButtonText={"No"}
                cancelAction={this.showHideDeletePopup}
              />
            )}{" "}
          </section>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state);
  return {
    salesUsersData: state.sales.get("salesUsersData"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSalesUsers: (url, data, type) =>
      dispatch(getServerDataWithTypes(url, data, type)),
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
    getStateList: (url, data, type) =>
      dispatch(getServerDataWithTypes(url, data, type)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SalesUsersListComp);



// WEBPACK FOOTER //
// ./web/components/admin/users/salesUser/SalesUsersList.jsx